<template>
  <div class="authentication">
    <div class="audit" style="line-height: 40px" v-if="this.a == 1">
      审核状态：
      <span :class="[this.audit_state == 1 ? 'Success' : 'red']">
        {{
          this.audit_state == 0
            ? "未审核"
            : this.audit_state == 1
            ? "审核通过"
            : this.audit_state == 2
            ? "已拒绝"
            : "审核中"
        }}
      </span>
      <el-button
        type="primary"
        plain
        size="small"
        style="margin-left: 14px"
        @click="amend"
        >修改</el-button
      >
    </div>
    <el-form
      :inline="true"
      :model="form2"
      class="demo-form-inline"
      v-if="this.a == 2"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label="审核状态：">
        <el-select
          style="height: 40px"
          v-model="form2.audit_state"
          placeholder="请选择"
        >
          <el-option label="未审核" :value="0"></el-option>
          <el-option label="通过审核" :value="1"></el-option>
          <el-option label="拒绝审核" :value="2"></el-option>
          <el-option label="审核中" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="原因："
        prop="remark"
        v-if="this.form2.audit_state !== 1"
      >
        <el-input
          :autosize="{ minRows: 1, maxRows: 4 }"
          type="textarea"
          v-model="form2.remark"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          style="margin-left: 14px"
          @click="submit"
          >提交</el-button
        >
        <el-button
          type="info"
          size="small"
          style="margin-left: 14px"
          @click="cancel"
          >取消</el-button
        >
      </el-form-item>
    </el-form>

    <el-collapse v-model="activeNames">
      <el-collapse-item title="法人/经办人身份证" name="1">
        <div class="identity-card" v-if="this.a == 2">
          <!-- 法人正面 -->
          <div style="margin-right: 40px">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              style="margin-bottom: 6px"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span>点击上传身份证正面照</span>
            </el-upload>
            <p style="margin: 0; text-align: center">法人身份证正面</p>
          </div>
          <!-- 法人反面 -->
          <div style="margin-right: 40px">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2"
              style="margin-bottom: 6px"
            >
              <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span>点击上传身份证反面照</span>
            </el-upload>
            <p style="margin: 0; text-align: center">法人身份证反面</p>
          </div>
          <!-- 经办人正面 -->
          <div style="margin-right: 40px">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess4"
              style="margin-bottom: 6px"
            >
              <img v-if="imageUrl4" :src="imageUrl4" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span>点击上传身份证正面照</span>
            </el-upload>
            <p style="margin: 0; text-align: center">经办人身份证正面</p>
          </div>
          <!-- 经办人反面 -->
          <div style="margin-right: 40px">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess5"
              style="margin-bottom: 6px"
            >
              <img v-if="imageUrl5" :src="imageUrl5" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span>点击上传身份证反面照</span>
            </el-upload>
            <p style="margin: 0; text-align: center">经办人身份证反面</p>
          </div>
        </div>
        <div class="identity-card" v-if="this.a == 1">
          <!-- 法人正面 -->
          <div style="margin-right: 40px">
            <el-image
              style="width: 230px; height: 150px; border: 1px solid #f5f7fa"
              :src="imageUrl"
              :preview-src-list="srcList"
              :z-index="20000000"
            >
              <div
                slot="error"
                style="
                  background-color: #f5f7fa;
                  text-align: center;
                  color: #c0c4cc;
                  line-height: 150px;
                "
              >
                正面/暂未上传
              </div>
            </el-image>
            <p style="margin: 0; text-align: center">法人身份证正面</p>
          </div>
          <!-- 法人反面 -->
          <div style="margin-right: 40px">
            <el-image
              style="width: 230px; height: 150px; border: 1px solid #f5f7fa"
              :src="imageUrl2"
              :preview-src-list="srcList"
              :z-index="20000000"
            >
              <div
                slot="error"
                style="
                  background-color: #f5f7fa;
                  text-align: center;
                  color: #c0c4cc;
                  line-height: 150px;
                "
              >
                反面/暂未上传
              </div>
            </el-image>
            <p style="margin: 0; text-align: center">法人身份证反面</p>
          </div>
          <!-- 经办人正面 -->
          <div style="margin-right: 40px">
            <el-image
              style="width: 230px; height: 150px; border: 1px solid #f5f7fa"
              :src="imageUrl4"
              :preview-src-list="srcList"
              :z-index="20000000"
            >
              <div
                slot="error"
                style="
                  background-color: #f5f7fa;
                  text-align: center;
                  color: #c0c4cc;
                  line-height: 150px;
                "
              >
                正面/暂未上传
              </div>
            </el-image>
            <p style="margin: 0; text-align: center">经办人身份证正面</p>
          </div>
          <!-- 经办人反面 -->
          <div style="margin-right: 40px">
            <el-image
              style="width: 230px; height: 150px; border: 1px solid #f5f7fa"
              :src="imageUrl5"
              :preview-src-list="srcList"
              :z-index="20000000"
            >
              <div
                slot="error"
                style="
                  background-color: #f5f7fa;
                  text-align: center;
                  color: #c0c4cc;
                  line-height: 150px;
                "
              >
                反面/暂未上传
              </div>
            </el-image>
            <p style="margin: 0; text-align: center">经办人身份证反面</p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="营业执照副本" name="2">
        <div class="business-license" v-if="this.a == 2">
          <!-- 营业执照 -->
          <div style="margin-right: 40px">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess3"
              style="margin-bottom: 6px"
            >
              <img v-if="imageUrl3" :src="imageUrl3" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span>点击上传营业执照副本</span>
            </el-upload>
            <p style="margin: 0; text-align: center">营业执照</p>
          </div>
          <!-- 信息安全责任书 -->
          <div style="margin-right: 40px">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess6"
              style="margin-bottom: 6px"
            >
              <img v-if="imageUrl6" :src="imageUrl6" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span>点击上传信息安全责任书</span>
            </el-upload>
            <p style="margin: 0; text-align: center">信息安全责任书</p>
          </div>
        </div>
        <div class="business-license" v-if="this.a == 1">
          <!-- 营业执照 -->
          <div style="margin-right: 40px">
            <el-image
              style="width: 230px; height: 150px; border: 1px solid #f5f7fa"
              :src="imageUrl3"
              :preview-src-list="srcList"
              :z-index="20000000"
            >
              <div
                slot="error"
                style="
                  background-color: #f5f7fa;
                  text-align: center;
                  color: #c0c4cc;
                  line-height: 150px;
                "
              >
                营业执照/暂未上传
              </div>
            </el-image>
            <p style="margin: 0; text-align: center">营业执照</p>
          </div>
          <!-- 信息安全责任书 -->
          <div style="margin-right: 40px">
            <el-image
              style="width: 230px; height: 150px; border: 1px solid #f5f7fa"
              :src="imageUrl6"
              :preview-src-list="srcList"
              :z-index="20000000"
            >
              <div
                slot="error"
                style="
                  background-color: #f5f7fa;
                  text-align: center;
                  color: #c0c4cc;
                  line-height: 150px;
                "
              >
                信息安全责任书/暂未上传
              </div>
            </el-image>
            <p style="margin: 0; text-align: center">信息安全责任书</p>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { postData, getData } from "@/api/index";
export default {
  data() {
    return {
      a: 1,
      imageUrl: "", // 法人正
      imageUrl2: "", // 法人反
      imageUrl3: "", // 营业执照
      imageUrl4: "", // 经办人正
      imageUrl5: "", // 经办人反
      imageUrl6: "", // 信息安全责任书
      activeNames: ["1", "2"],
      srcList: [],
      row: {},
      action: "",
      form: {
        id: "",
        audit_state: "",
        type: [],
        remark: "",
      },
      form2: {
        id_card_on: "", // 法人正
        id_card_back: "", // 法人反
        license: "", // 营业执照
        manager_idcard_on: "", // 经办人正
        manager_idcard_back: "", // 经办人反
        responsibility: "", // 信息安全责任书
        audit_state: "",
        remark: "",
      },
      audit_state: "",
      rules: {
        remark: [{ required: true, message: "请填写原因", trigger: "blur" }],
      },
      formLabelWidth: "120px",
      currentPage: 1, //默认开始页面
    };
  },
  props: {
    rowid: Number,
  },
  watch: {
    message(newVal) {
      this.row = newVal;
    },
  },
  created() {
    this.action = this.hostName + "/common/uploadAction";
    this.addAuditing();
  },

  methods: {
    // 修改
    amend() {
      this.a = 2;
    },
    // 取消
    cancel() {
      this.a = 1;
    },
    addAuditing() {
      getData("agent/AgentVerifyAction", { id: this.rowid }).then((res) => {
        if (res.code !== 200) {
          this.$message.error(res.msg);
          return true;
        }
        this.imageUrl = res.data.id_card_on;
        this.form2.id_card_on = res.data.id_card_on;
        this.imageUrl2 = res.data.id_card_back;
        this.form2.id_card_back = res.data.id_card_back;
        this.imageUrl3 = res.data.license;
        this.form2.license = res.data.license;
        this.imageUrl4 = res.data.manager_idcard_on;
        this.form2.manager_idcard_on = res.data.manager_idcard_on;
        this.imageUrl5 = res.data.manager_idcard_back;
        this.form2.manager_idcard_back = res.data.manager_idcard_back;
        this.imageUrl6 = res.data.responsibility;
        this.form2.responsibility = res.data.responsibility;
        this.audit_state = res.data.audit_state;
        if (res.data.audit_state == null) {
          this.form2.audit_state = 3;
        } else {
          this.form2.audit_state = res.data.audit_state;
        }
        this.form2.remark = res.data.company.remark;
        this.srcList.push(res.data.id_card_on);
        this.srcList.push(res.data.id_card_back);
        this.srcList.push(res.data.license);
        this.srcList.push(res.data.manager_idcard_on);
        this.srcList.push(res.data.manager_idcard_back);
        this.srcList.push(res.data.responsibility);
      });
    },
    // 法人正
    handleAvatarSuccess(res) {
      this.form2.id_card_on = res.data.src;
      this.imageUrl = res.data.src;
    },
    // 法人反
    handleAvatarSuccess2(res) {
      this.form2.id_card_back = res.data.src;
      this.imageUrl2 = res.data.src;
    },
    // 营业执照
    handleAvatarSuccess3(res) {
      this.form2.license = res.data.src;
      this.imageUrl3 = res.data.src;
    },
    // 经办人正
    handleAvatarSuccess4(res) {
      this.form2.manager_idcard_on = res.data.src;
      this.imageUrl4 = res.data.src;
    },
    // 经办人反
    handleAvatarSuccess5(res) {
      this.form2.manager_idcard_back = res.data.src;
      this.imageUrl5 = res.data.src;
    },
    // 信息安全责任书
    handleAvatarSuccess6(res) {
      this.form2.responsibility = res.data.src;
      this.imageUrl6 = res.data.src;
    },
    submit() {
      let form = {
        id: this.rowid,
        id_card_on: this.form2.id_card_on,
        id_card_back: this.form2.id_card_back,
        license: this.form2.license,
        manager_idcard_on: this.form2.manager_idcard_on,
        manager_idcard_back: this.form2.manager_idcard_back,
        responsibility: this.form2.responsibility,
        audit_state: this.form2.audit_state,
        remark: this.form2.remark,
      };
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          postData("agent/AgentSubmitVerifyAction", form).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.audit_state = 1;
              this.a = 1;
              this.addAuditing();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.authentication {
  .audit {
    color: #333333;
    font-size: 14px;
    .red {
      color: #fd4848;
    }
    .Success {
      color: #67c23a;
    }
  }
  .demo-form-inline {
    .el-form-item {
      margin-bottom: 0;
    }
    /deep/.el-form-item__content {
      line-height: 40px;
    }
    /deep/.el-textarea__inner {
      min-height: 40px !important;
      height: 40px !important;
    }
    /deep/.el-input__inner {
      line-height: 40px;
      height: 40px !important;
    }
  }
  .el-collapse {
    margin-top: 15px;
  }
  .identity-card,
  .business-license {
    display: flex;
    .avatar-uploader {
      width: 230px;
      height: 150px;
      border: 1px solid #ebebeb !important;
      position: relative;
      overflow: hidden;
      background-color: #fafafa;

      span {
        width: 230px;
        position: absolute;
        bottom: 20%;
        left: 0%;
        color: #999999;
        font-size: 14px;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #c6c6c6;
      width: 230px;
      height: 130px;
      line-height: 130px;
      text-align: center;
      background-color: #fafafa;
    }
    .avatar {
      width: 230px;
      height: 150px;
      display: block;
    }
    img {
      position: relative;
      z-index: 1;
    }
  }
  .business-license {
    margin-bottom: 20px;
  }
}
/deep/.v-modal {
  width: 0 !important;
}
/deep/.el-collapse-item__header {
  height: 34px;
  line-height: 34px;
  background-color: #f7fbff;
  font-size: 14px;
  color: #333333;
  padding: 0 17px;
}
/deep/.el-collapse-item__content {
  padding-top: 25px;
}
</style>
